"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalProvider = ModalProvider;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ModalBase = _interopRequireDefault(require("./ModalBase.js"));

var _CIconButton = _interopRequireDefault(require("./CIconButton.js"));

var _CFontIcon = _interopRequireDefault(require("./CFontIcon.js"));

var _chunk6104512b = require("./chunk-6104512b.js");

var _type = require("./type.js");

require("./style.js");

require("classnames");

require("./CButton.js");

require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function useOnKeyDown(key, handler) {
  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      var keyName = event.key || null;
      var keyCode = event.keyCode || null;

      if (key === keyCode || key == keyName) {
        handler(event);
      }
    };

    document.addEventListener("keydown", listener);
    return function () {
      document.removeEventListener("keydown", listener);
    };
  }, [key, handler]);
}

function _templateObject4() {
  var data = (0, _chunkB2edacfb.a)(["\n  width: 100%;\n  background-color: white;\n  bottom: 0;\n  border-radius: 12px;\n  z-index: 10;\n  order: 9;\n  padding: 15px;\n  text-align: center;\n  button {\n    margin-left: 10px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: block;\n  box-sizing: border-box;\n  flex: 1;\n  order: 1;\n  z-index: 0;\n  padding: 15px;\n  overflow-y: scroll;\n  overflow: auto;\n  background: linear-gradient(white 99%, rgba(200, 200, 200, 0)),\n    linear-gradient(rgba(255, 255, 255, 0), white 99%) 0 100%,\n    radial-gradient(\n      farthest-corner at 50% 0,\n      rgba(0, 0, 0, 0.2),\n      rgba(0, 0, 0, 0)\n    ),\n    radial-gradient(\n        farthest-corner at 50% 100%,\n        rgba(0, 0, 0, 0.2),\n        rgba(0, 0, 0, 0)\n      )\n      0 100%;\n  background-repeat: no-repeat;\n  background-color: white;\n  background-size: 100% 10px, 100% 10px, 100% 2px, 100% 2px;\n  background-attachment: local, local, scroll, scroll;\n  .container {\n    margin: 0 auto;\n    max-width: 800px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n  order: 0;\n  display: block;\n  position: relative;\n  height: auto;\n  min-height: 120px;\n  padding: 15px;\n  text-align: center;\n  -webkit-backface-visibility: hidden;\n  z-index: 2;\n  .header-content {\n    margin-top: 5px;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  z-index: 2;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  .close-button {\n    z-index: 3;\n    position: absolute;\n    top: 25px;\n    right: 20px;\n    flex-direction: column;\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Context = _react.default.createContext();

var CModal = function CModal(_ref) {
  var backgroundColor = _ref.backgroundColor,
      className = _ref.className,
      children = _ref.children,
      id = _ref.id,
      onClose = _ref.onClose,
      isOpen = _ref.isOpen,
      title = _ref.title,
      subtitle = _ref.subtitle,
      label = _ref.label,
      effect = _ref.effect,
      type = _ref.type;
  var modalNode = (0, _react.useContext)(Context);
  useOnKeyDown("Escape", onClose);
  var width = type === "full" ? "100%" : type === "small" ? "30%" : "40%";
  var height = type === "full" ? "100%" : type === "small" ? "300px" : "500px";
  var hasHeader = label || title || subtitle;
  return modalNode ? _reactDom.default.createPortal(_react.default.createElement(_ModalBase.default, {
    id: id,
    className: className,
    visible: isOpen,
    width: width,
    height: height,
    effect: effect,
    onClickAway: onClose
  }, _react.default.createElement(ModalInnerContainer, {
    backgroundColor: backgroundColor
  }, _react.default.createElement(CloseButton, {
    type: type,
    onClose: onClose
  }), hasHeader && _react.default.createElement(ModalHeader, null, _react.default.createElement("div", {
    className: "header-content"
  }, _react.default.createElement(_type.H5, {
    type: "tertiary"
  }, label), _react.default.createElement(_type.H2, null, title), _react.default.createElement(_type.P, null, subtitle))), children)), modalNode) : null;
};

function ModalProvider(_ref2) {
  var children = _ref2.children;
  var modalRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _chunkB2edacfb.l)(_useState, 2),
      context = _useState2[0],
      setContext = _useState2[1];

  (0, _react.useEffect)(function () {
    setContext(modalRef.current);
  }, []);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Context.Provider, {
    value: context
  }, children), _react.default.createElement("div", {
    ref: modalRef
  }));
}

var CloseButton = function CloseButton(_ref3) {
  var type = _ref3.type,
      onClose = _ref3.onClose;
  return _react.default.createElement(_CIconButton.default, {
    className: "close-button",
    border: "none",
    onClick: onClose
  }, _react.default.createElement(_CFontIcon.default, {
    className: "fa fa-times",
    altText: "close",
    fontSize: 20
  }), type === "full" && _react.default.createElement(_type.Caption, null, "Esc"));
};

var grayBackgroundColor = function grayBackgroundColor(_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor === "gray" && (0, _styledComponents.css)(["&& > *{background:", ";}"], function (_ref5) {
    var theme = _ref5.theme;
    return theme["$gray-1"];
  });
};

var ModalInnerContainer = _styledComponents.default.div.withConfig({
  displayName: "CModal__ModalInnerContainer",
  componentId: "sc-1dwo1a8-0"
})(_templateObject(), grayBackgroundColor);

var ModalHeader = _styledComponents.default.header.withConfig({
  displayName: "CModal__ModalHeader",
  componentId: "sc-1dwo1a8-1"
})(_templateObject2());

var ModalContent = _styledComponents.default.main.withConfig({
  displayName: "CModal__ModalContent",
  componentId: "sc-1dwo1a8-2"
})(_templateObject3());

var ModalFooter = _styledComponents.default.footer.withConfig({
  displayName: "CModal__ModalFooter",
  componentId: "sc-1dwo1a8-3"
})(_templateObject4());

CModal.Footer = function (props) {
  return _react.default.createElement(ModalFooter, null, props.children);
};

CModal.Content = function (props) {
  return _react.default.createElement(ModalContent, null, _react.default.createElement(_chunk6104512b.a, props, props.children));
};

CModal.Footer = ModalFooter;
CModal.displayName = "CModal";
CModal.Footer.displayName = "CModal.Footer";
CModal.Content.displayName = "CModal.Content";
CModal.propTypes = {
  backgroundColor: _propTypes.default.oneOf(["white", "gray"]),
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  onClose: _propTypes.default.func.isRequired,
  isOpen: _propTypes.default.bool,
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string,
  label: _propTypes.default.string,
  effect: _propTypes.default.oneOf(["fadeInDown", "fadeInUp", "fadeInLeft", "fadeInRight"]),
  type: _propTypes.default.oneOf(["small", "medium", "full"])
};
CModal.defaultProps = {
  backgroundColor: "white",
  isOpen: true,
  effect: "fadeInUp",
  type: "medium",
  onClickAway: null
};
ModalProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ModalProvider"
};
var _default = CModal;
exports.default = _default;
ModalProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ModalProvider"
};